import { Capacitor } from '@capacitor/core';

/**
 * Platform detection utilities for handling differences between
 * web app (Android/Desktop browsers) and native iOS app
 */
export const PlatformUtils = {
  /**
   * Check if running as native Capacitor app (iOS)
   */
  isNativeApp: (): boolean => {
    return Capacitor.isNativePlatform();
  },

  /**
   * Check if running as iOS native app
   */
  isIOSApp: (): boolean => {
    return Capacitor.getPlatform() === 'ios';
  },

  /**
   * Check if running in web browser
   */
  isWeb: (): boolean => {
    return Capacitor.getPlatform() === 'web';
  },

  /**
   * Check if iOS device (web or native)
   */
  isIOSDevice: (): boolean => {
    return /iPad|iPhone|iPod/.test(navigator.userAgent);
  },

  /**
   * Check if Android device (web only - we won't have Android native)
   */
  isAndroidDevice: (): boolean => {
    return /Android/.test(navigator.userAgent);
  },

  /**
   * Should use native speech recognition?
   * Returns true for iOS native app
   */
  useNativeSpeech: (): boolean => {
    return Capacitor.getPlatform() === 'ios';
  },

  /**
   * Should use web speech recognition?
   * Returns true for web browsers (Android, Desktop, iOS Safari)
   */
  useWebSpeech: (): boolean => {
    return Capacitor.getPlatform() === 'web';
  },

  /**
   * Get current platform
   */
  getPlatform: (): 'ios' | 'web' => {
    return Capacitor.getPlatform() as 'ios' | 'web';
  },

  /**
   * Log platform information (useful for debugging)
   */
  logPlatformInfo: (): void => {
    console.log('Platform Info:', {
      platform: Capacitor.getPlatform(),
      isNative: Capacitor.isNativePlatform(),
      isIOSApp: PlatformUtils.isIOSApp(),
      isWeb: PlatformUtils.isWeb(),
      userAgent: navigator.userAgent,
    });
  },
};

